<template>
    <module-card :nextDisabled="nextDisabled">
        <template v-slot:header>
            <div class="club">
                <v-img rel="preload" :src="require('@/assets/StepUpStepBack/club_background.png')" alt="Night Club">
                    <v-img rel="preload" class="club-art" :style="{ right: `${artCurrentPosition}vw` }" :src="require('@/assets/StepUpStepBack/art_side.png')" alt="Art"></v-img>
                    <v-img rel="preload" class="club-nico" :style="{ right: `${nicoCurrentPosition}vw` }" :src="require('@/assets/StepUpStepBack/nico_side.png')" alt="Nico"></v-img>
                    <v-img rel="preload" class="club-p" :style="{ right: `${pCurrentPosition}vw` }" :src="require('@/assets/StepUpStepBack/p_side.png')" alt="P"></v-img>
                    <v-img rel="preload" class="club-tommy" :style="{ right: `${tommyCurrentPosition}vw` }" :src="require('@/assets/StepUpStepBack/tommy_side.png')" alt="Tommy"></v-img>
                    <v-img rel="preload" class="club-you" :style="{ right: `${youCurrentPosition}vw` }" :src="require('@/assets/StepUpStepBack/you.png')" alt="You"></v-img>
                    <v-img rel="preload" class="club-vip" :src="require('@/assets/StepUpStepBack/club_foreground.png')" alt="VIP Line"></v-img>
                </v-img>
            </div>
        </template>

        <div>
            <span class="d-inline-block mb-2">{{ prompt.prompt }}</span>
            <div v-for="choice in choices" :key="choice.id" :class="[isSelected(choice.id) ? 'primary white--text' : 'grey lighten-3']" class="pa-3 mb-1" @click.stop="select(choice.id)" v-ripple>
                <span>{{ choice.text }}</span>
            </div>
        </div>
    </module-card>
</template>

<script>
    import { sync, get } from 'vuex-pathify';
    import { reduce, filter } from 'lodash';

    export default {
        data() {
            return {
                nicoStartingPosition: 5,
                artStartingPosition: 20,
                youStartingPosition: 35,
                tommyStartingPosition: 50,
                pStartingPosition: 65,
                stepOffset: 2
            };
        },
        props: {
            promptId: {
                type: Number,
                required: true
            }
        },
        methods: {
            nextDisabled() {
                return this.myChoice === null;
            },
            select(response) {
                this.$store.set(`stepUpStepBackPrompts@${this.promptId}.myChoice`, response);
            },
            isSelected(id) {
                if (parseInt(id) === parseInt(this.myChoice)) return true;
                else return false;
            }
        },
        computed: {
            allPrompts: get('stepUpStepBackPrompts'),
            choices: sync('stepUpStepBackChoices'),
            myChoice() {
                return this.$store.get(`stepUpStepBackPrompts@${this.promptId}.myChoice`);
            },
            prompt() {
                return this.$store.get(`stepUpStepBackPrompts@${this.promptId}`);
            },
            artCurrentPosition() {
                return reduce(
                    filter(this.allPrompts, ({ id }) => (this.myChoice ? id <= this.promptId : id < this.promptId)),
                    (total, o) => total + (o.artChoice === 1 ? o.notMeValue : o.artChoice === 2 ? o.meValue : o.naValue) * this.stepOffset,
                    this.artStartingPosition
                );
            },
            nicoCurrentPosition() {
                return reduce(
                    filter(this.allPrompts, ({ id }) => (this.myChoice ? id <= this.promptId : id < this.promptId)),
                    (total, o) => total + (o.nicoChoice === 1 ? o.notMeValue : o.nicoChoice === 2 ? o.meValue : o.naValue) * this.stepOffset,
                    this.nicoStartingPosition
                );
            },
            youCurrentPosition() {
                return reduce(
                    filter(this.allPrompts, ({ id }) => (this.myChoice ? id <= this.promptId : id < this.promptId)),
                    (total, o) => total + (o.myChoice === 1 ? o.notMeValue : o.myChoice === 2 ? o.meValue : o.naValue) * this.stepOffset,
                    this.youStartingPosition
                );
            },
            pCurrentPosition() {
                return reduce(
                    filter(this.allPrompts, ({ id }) => (this.myChoice ? id <= this.promptId : id < this.promptId)),
                    (total, o) => total + (o.philipChoice === 1 ? o.notMeValue : o.philipChoice === 2 ? o.meValue : o.naValue) * this.stepOffset,
                    this.pStartingPosition
                );
            },
            tommyCurrentPosition() {
                return reduce(
                    filter(this.allPrompts, ({ id }) => (this.myChoice ? id <= this.promptId : id < this.promptId)),
                    (total, o) => total + (o.tommyChoice === 1 ? o.notMeValue : o.tommyChoice === 2 ? o.meValue : o.naValue) * this.stepOffset,
                    this.tommyStartingPosition
                );
            }
        }
    };
</script>

<style lang="scss" scoped>
    .club {
        position: relative;
        top: 0;
        left: 0;
        width: 100vw;
        min-width: 100%;
        .club-art {
            position: absolute;
            max-height: 100%;
            width: 7vw;
            bottom: 2px;
            z-index: 2;
        }
        .club-nico {
            position: absolute;
            max-height: 100%;
            width: 7vw;
            bottom: 2px;
            z-index: 5;
        }
        .club-you {
            position: absolute;
            max-height: 100%;
            width: 7vw;
            bottom: 2px;
            z-index: 4;
        }
        .club-p {
            position: absolute;
            max-height: 100%;
            width: 7vw;
            bottom: 2px;
            z-index: 6;
        }
        .club-tommy {
            position: absolute;
            max-height: 100%;
            width: 7vw;
            bottom: 2px;
            z-index: 3;
        }
        .club-vip {
            position: absolute;
            max-height: 100%;
            width: 100%;
            z-index: 10;
        }
    }
</style>
